'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var assistTitanClient = require('./assistTitanClient.js');
var index = require('../ClaimBuilder/index.js');
var SessionContext = require('../SessionContext.js');

const TitanAnalyticsContext = /*#__PURE__*/React.createContext(undefined);
const TitanAnalyticsProvider = TitanAnalyticsContext.Provider;
const useTitanAnalytics = () => {
  const context = React.useContext(TitanAnalyticsContext);
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const {
    source,
    localeLanguage,
    localeCountry,
    portalType,
    orderNumber
  } = SessionContext.useSession();
  const {
    sourceWriteKey,
    dataPlaneUrl,
    extra_properties
  } = context ?? {};
  const titanAnalytics = React.useMemo(() => {
    if (!sourceWriteKey || !dataPlaneUrl) {
      return undefined;
    }

    // titan relies on browser crypto API
    if (typeof window !== 'undefined') {
      return assistTitanClient["default"]({
        titanConfig: {
          sourceWriteKey,
          url: dataPlaneUrl
        },
        portalType,
        orderNumber,
        claimType: claimType,
        source,
        locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
        extra_properties
      });
    }
    return undefined;
  }, [sourceWriteKey, dataPlaneUrl, claimType, orderNumber, localeCountry, localeLanguage, source, portalType, extra_properties]);
  return titanAnalytics;
};

exports.TitanAnalyticsContext = TitanAnalyticsContext;
exports.TitanAnalyticsProvider = TitanAnalyticsProvider;
exports["default"] = useTitanAnalytics;
